import { queryOptions } from '@tanstack/react-query';
import type {
  GetStreamConfigData,
  GetStreamConfigResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getStreamConfigKey = () => ['getstream', 'config'] as const;

const getStreamConfigUrl: GetStreamConfigData['url'] =
  'integrations/getstream/config';

export const getStreamConfigOptions = <T = GetStreamConfigResponse>() =>
  queryOptions<GetStreamConfigResponse, unknown, T>({
    queryKey: getStreamConfigKey(),
    queryFn: () => PrivateApi.get(getStreamConfigUrl).json(),
    refetchInterval: 5 * 60 * 1000, // 5 minutes,
  });
